import {
  ComplianceEntity,
  ComplianceEntityType,
  Payee
} from "@wingspanhq/wingspan-api-sdk";
import { TinType } from "@wingspanhq/payments/dist/interfaces/taxForm";
import { ContractorTaxFormValues } from "../../../hooks/useContractorTaxCompliance";

/**
 * Seeds the edit-tax-info form from the v3 Payee (display name/company) + the
 * payer-owned ComplianceEntity (W-9 tax identity). SSN/EIN are write-only on the
 * compliance entity and are never echoed back, so they seed empty — the payer
 * re-enters them to make an edit. companyStructure likewise re-selected.
 */
export const getDefaultValues = (
  payee?: Payee,
  complianceEntity?: ComplianceEntity
): ContractorTaxFormValues => {
  const isBusiness = complianceEntity?.type === ComplianceEntityType.BUSINESS;
  const address = complianceEntity?.physicalAddress;

  return {
    name: payee?.profile?.displayName || "",
    companyName: payee?.profile?.company?.doingBusinessAs || "",
    tinType: isBusiness ? TinType.Business : TinType.Individual,
    individual: {
      firstName: complianceEntity?.individualLegalName?.givenName || undefined,
      lastName: complianceEntity?.individualLegalName?.familyName || undefined,
      ssn: undefined
    },
    business: {
      legalBusinessName: complianceEntity?.legalName || undefined,
      disregardedEntityName: complianceEntity?.doingBusinessAs || undefined,
      ein: undefined,
      companyStructure: undefined
    },
    address: {
      addressLine1: address?.line1 || undefined,
      addressLine2: address?.line2 || undefined,
      city: address?.city || undefined,
      state: address?.state || undefined,
      postalCode: address?.postalCode || undefined,
      country: address?.country || "US"
    }
  };
};
